/**
 * Game status utilities shared across admin-web and electron-client
 */
/**
 * Get a status icon emoji for a game status
 *
 * @param status - The game status string
 * @returns An emoji representing the status
 *
 * @example
 * ```ts
 * getStatusIcon('active'); // '🟢'
 * getStatusIcon('completed'); // '⚪'
 * ```
 */
export function getStatusIcon(status) {
    switch (status) {
        case 'draft':
            return '📝';
        case 'pre_registration':
            return '📨';
        case 'pool_creation':
            return '👑';
        case 'team_creation':
            return '⚙️';
        case 'pre_game':
            return '🎯';
        case 'lobby':
            return '🛋️';
        case 'active':
            return '🟢';
        case 'round_ending':
            return '🏁';
        case 'waiting':
            return '🟡';
        case 'completed':
            return '⚪';
        case 'abandoned':
            return '⛔';
        default:
            return '⚪';
    }
}
/**
 * Get full status label information including icon, text, and CSS class
 *
 * @param status - The game status string
 * @returns Object with icon, label text, and className
 *
 * @example
 * ```ts
 * getStatusLabel('active'); // { icon: '🟢', label: 'Active', className: 'status-active' }
 * ```
 */
export function getStatusLabel(status) {
    switch (status) {
        case 'draft':
            return { icon: '📝', label: 'Draft', className: 'status-draft' };
        case 'pre_registration':
            return { icon: '📨', label: 'Pre-registration', className: 'status-pre-registration' };
        case 'pool_creation':
            return { icon: '👑', label: 'Pool Creation', className: 'status-pool-creation' };
        case 'team_creation':
            return { icon: '⚙️', label: 'Team Creation', className: 'status-team-creation' };
        case 'pre_game':
            return { icon: '🎯', label: 'Pre-Game', className: 'status-pre-game' };
        case 'lobby':
            return { icon: '🛋️', label: 'Lobby', className: 'status-lobby' };
        case 'active':
            return { icon: '🟢', label: 'Active', className: 'status-active' };
        case 'round_ending':
            return { icon: '🏁', label: 'Round Ending', className: 'status-round-ending' };
        case 'waiting':
            return { icon: '🟡', label: 'Waiting for Players', className: 'status-waiting' };
        case 'completed':
            return { icon: '⚪', label: 'Completed', className: 'status-completed' };
        case 'abandoned':
            return { icon: '⛔', label: 'Abandoned', className: 'status-abandoned' };
        default:
            return { icon: '⚪', label: status, className: '' };
    }
}
